import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// This component is used to protect admin routes
function AdminRoute({ children }) {
  const { currentUser, isAdmin } = useAuth();

  if (!currentUser) {
    // Redirect to login if not logged in
    return <Navigate to="/login" />;
  }

  if (!isAdmin) {
    // Redirect to home if logged in but not admin
    return <Navigate to="/" />;
  }

  // Render children if user is admin
  return children;
}

export default AdminRoute; 